export enum EContractSpecialConditionCategory {
  PAYMENT_ARRANGEMENTS = "PAYMENT_ARRANGEMENTS",
  HEALTH_BIOSEC = "HEALTH_BIOSEC",
  REJECTION_DRAFTING = "REJECTION_DRAFTING",
  TRANSPORT = "TRANSPORT",
  WEIGHT_YIELD = "WEIGHT_YIELD",
  SERVICES = "SERVICES",
  COMPLIANCE = "COMPLIANCE",
  OTHER = "OTHER",
}

export const EContractSpecialConditionCategoryLabel: Record<
  EContractSpecialConditionCategory,
  string
> = {
  [EContractSpecialConditionCategory.PAYMENT_ARRANGEMENTS]:
    "Payment Arrangements",
  [EContractSpecialConditionCategory.HEALTH_BIOSEC]: "Health/Biosec",
  [EContractSpecialConditionCategory.REJECTION_DRAFTING]: "Rejection/Drafting",
  [EContractSpecialConditionCategory.TRANSPORT]: "Transport",
  [EContractSpecialConditionCategory.WEIGHT_YIELD]: "Weight/Yield",
  [EContractSpecialConditionCategory.SERVICES]: "Services",
  [EContractSpecialConditionCategory.COMPLIANCE]: "Compliance",
  [EContractSpecialConditionCategory.OTHER]: "Other",
};
